export default __webpack_public_path__ + "static/pxp-feedback-kiosk-stand-fee21a08b5faa6afcaa02e2d33d6049c.webp";